import { C } from "@/lib/brand";

export function Field({ label, value, onChange, onBlur, placeholder, type = "text", testId, autoFocus, required, inputMode, name, id, autoComplete }) {
  return (
    <label style={{ display: "block", marginTop: 18, width: "100%", boxSizing: "border-box" }} htmlFor={id}>
      <div
        style={{
          fontSize: 11,
          fontWeight: 800,
          letterSpacing: "0.2em",
          textTransform: "uppercase",
          color: C.warmGray,
          marginBottom: 8,
        }}
      >
        {label}
        {required && <span style={{ color: C.coral }}> *</span>}
      </div>
      <input
        data-testid={testId}
        type={type}
        value={value}
        autoFocus={autoFocus}
        inputMode={inputMode}
        name={name}
        id={id}
        autoComplete={autoComplete}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          width: "100%",
          maxWidth: "100%",
          padding: "16px 18px",
          background: C.pure,
          border: `1.5px solid ${C.warmGray3}`,
          fontSize: 16,
          color: C.ink,
          outline: "none",
          fontFamily: "inherit",
          boxSizing: "border-box",
          minWidth: 0,
        }}
        onFocus={(e) => (e.target.style.borderColor = C.ink)}
        onBlur={(e) => {
          e.target.style.borderColor = C.warmGray3;
          if (onBlur) onBlur();
        }}
      />
    </label>
  );
}

export function TextArea({ label, value, onChange, placeholder, rows = 4, testId }) {
  return (
    <label style={{ display: "block", marginTop: 18 }}>
      <div
        style={{
          fontSize: 11,
          fontWeight: 800,
          letterSpacing: "0.2em",
          textTransform: "uppercase",
          color: C.warmGray,
          marginBottom: 8,
        }}
      >
        {label}
      </div>
      <textarea
        data-testid={testId}
        rows={rows}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          width: "100%",
          padding: "16px 18px",
          background: C.pure,
          border: `1.5px solid ${C.warmGray3}`,
          fontSize: 16,
          color: C.ink,
          outline: "none",
          fontFamily: "inherit",
          resize: "vertical",
        }}
        onFocus={(e) => (e.target.style.borderColor = C.ink)}
        onBlur={(e) => (e.target.style.borderColor = C.warmGray3)}
      />
    </label>
  );
}

export function Select({ label, value, onChange, options, testId }) {
  return (
    <label style={{ display: "block", marginTop: 18 }}>
      <div
        style={{
          fontSize: 11,
          fontWeight: 800,
          letterSpacing: "0.2em",
          textTransform: "uppercase",
          color: C.warmGray,
          marginBottom: 8,
        }}
      >
        {label}
      </div>
      <select
        data-testid={testId}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        style={{
          width: "100%",
          padding: "16px 18px",
          background: C.pure,
          border: `1.5px solid ${C.warmGray3}`,
          fontSize: 16,
          color: C.ink,
          outline: "none",
          fontFamily: "inherit",
          appearance: "none",
        }}
      >
        <option value="">Select…</option>
        {options.map((o) => (
          <option key={o.value || o} value={o.value || o}>
            {o.label || o}
          </option>
        ))}
      </select>
    </label>
  );
}

export function PillToggle({ label, active, onClick, testId }) {
  return (
    <button
      onClick={onClick}
      data-testid={testId}
      style={{
        padding: "12px 18px",
        background: active ? C.ink : C.pure,
        color: active ? C.cream : C.ink,
        border: `1.5px solid ${active ? C.ink : C.warmGray3}`,
        fontSize: 13,
        fontWeight: 700,
        letterSpacing: "0.05em",
        cursor: "pointer",
        transition: "all 120ms ease",
      }}
    >
      {label}
    </button>
  );
}
